(function () {
  function initProductInfoTabs(root) {
    if (!root || root.dataset.tabsReady === 'true') return;
    root.dataset.tabsReady = 'true';

    var tabs = root.querySelectorAll('[data-product-info-tab]');
    var panels = root.querySelectorAll('[data-product-info-panel]');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-product-info-tab');

        tabs.forEach(function (btn) {
          var isActive = btn === tab;
          btn.classList.toggle('is-active', isActive);
          btn.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          var isActive = panel.getAttribute('data-product-info-panel') === target;
          panel.classList.toggle('is-active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      });
    });
  }

  function initProductInfoCollapsible(root) {
    if (!root || root.dataset.collapsibleReady === 'true') return;
    root.dataset.collapsibleReady = 'true';

    var toggle = root.querySelector('[data-product-info-toggle]');
    var content = root.querySelector('[data-product-info-content]');
    if (!toggle || !content) return;

    toggle.addEventListener('click', function () {
      var isOpen = root.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

      if (isOpen) {
        content.removeAttribute('hidden');
      } else {
        content.setAttribute('hidden', '');
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-product-info-tabs]').forEach(initProductInfoTabs);
    document.querySelectorAll('[data-product-info-collapsible]').forEach(initProductInfoCollapsible);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
